import { makeStyles } from '@material-ui/core/styles';
import fonts from 'styles/fonts';
import spacing from 'styles/spacing';
import { colors } from 'styles/colors';

const useStyles = makeStyles({
  messageContent: {
    display: 'flex',
    alignItems: 'center',
    '& > *:first-child': {
      marginRight: '8px',
    },
  },
  messageText: {
    fontSize: `${fonts.sizes.small}`,
    color: colors.white,
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.25px',
    lineHeight: '20px',
  },
  snackbarBody: {
    '& .MuiSnackbarContent-root': {
      minWidth: 'auto',
    },
  },
  close: {
    padding: spacing.xxxsmall,
  },
});

export default useStyles;
